import { useCallback, useState } from 'react';
import { Trans } from '@lingui/macro';

import './style.scss';

const Input = ({ id, label, type, onChange, min, value = '', required = false, error = "", onBlur, disabled = false }) => {
    const [active, setActive] = useState(value.toString().length > 0);

    const onFocus = () => { 
        setActive(true);
    }
 
    const handleOnChange = (e) => {
        onChange && onChange(e.currentTarget.value);
    }

    const handleOnBlur = useCallback(() => {
        onBlur && onBlur();
        if (!value.length) {
            setActive(false);
        }
    }, [value, onBlur])

    return (
        <div className={`input-group ${active ? 'active' : ''} ${type} ${required && error ? "invalid" : ""}`}>
            <h6 className={`${disabled ? 'disabled' : ''}`} htmlFor={id}><Trans id={label} values={label} />{required ? ' *' : ''}</h6>
            <input disabled={disabled} type={type} id={id} onFocus={onFocus} min={min} value={value} onBlur={handleOnBlur} onChange={handleOnChange} />
            {required && error && <p className="error"><Trans id={error} values={error} /></p>}
        </div>
    )
}

export default Input;